export default __webpack_public_path__ + "static/media/pucp.a9d56831.jpg";